import { BrandLoadingScreen } from "@/components/Layout/BrandLoadingScreen/BrandLoadingScreen";

export const WelcomeLoadingSpinner = () => <BrandLoadingScreen />;
